import { IrIncomeTypeUsecase, TransactionCode, UserDefinedRow, CarBenefitUsecase } from "../../model";
import { IncomeTypeMetadata, IncomeTypesLogic, } from "../../logic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for IrIncomeTypeUsecase  */
export class IrIncomeTypeUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  public updateUsecase(row: UserDefinedRow): void {
    const data: IrIncomeTypeUsecase = row.data ?? {};
    // Get code data by kind first (new version) and then using the old method.
    const codeData = this.getCodeDataByNumber(data?.irData?.code) ?? this.getCodeDataByTransaction(data?.kind);
    if (codeData) {
      data.irData = data.irData ?? {};
      data.irData.code = codeData.code;
      data.kind = codeData.transactionCode;
    }
  }

  /** Gets validation message for IrIncomeTypeUsecase  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage | undefined {
    const data: IrIncomeTypeUsecase = row.data ?? {};
    const codeData = this.getCodeDataByNumber(data?.irData?.code) ?? this.getCodeDataByTransaction(data?.kind);
    if (!codeData) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType",
      };
    }

    if (codeData.transactionCode === TransactionCode.CarBenefit) {
      const carBenefit: CarBenefitUsecase = data.irData?.carBenefit || {};
      if (carBenefit.emissionsValue && carBenefit.emissionsValue < 0 || carBenefit.emissionsValue &&carBenefit.emissionsValue > 100) {
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.carBenefit.invalidEmissionValues",
        };
      }
      if (!carBenefit.ageGroup || carBenefit.kilometers == null) {
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.carBenefit.default",
        };
      }
    }

    return undefined;
  }

  private getCodeDataByNumber(code: number | null | undefined): IncomeTypeMetadata | undefined {
    if (!code) {
      return undefined;
    }

    return IncomeTypesLogic.getAll().find( (x) => x.code === code);
  }

  private getCodeDataByTransaction(transactionCode: TransactionCode | null | undefined): IncomeTypeMetadata | undefined {
    if ( !transactionCode ||
        transactionCode === TransactionCode.Unknown ||
        (transactionCode as any) === "undefined" ) {

      return undefined;
    }
    return IncomeTypesLogic.getAll().find( (x) => x.transactionCode === transactionCode);
  }

  private isIrIncomeTypeLabel(label: string): boolean {
    return IncomeTypesLogic.getAll().some( (x) => x.label === label);
  }
}
